import {
  MessageAddedEntry,
  Message as MessageT,
} from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

import { getMessageSanitizationChannel } from 'app/utils/htmlSanitizer';

import { Message } from '../../../conversation/components/message';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import styles from './logEntry/logEntry.module.scss';
import { UserLink } from './userLink/userLink';

type MessageAddedProps = {
  entry: MessageAddedEntry;
  messages: Array<MessageT>;
};

export const MessageAdded = ({
  entry,
  messages,
}: MessageAddedProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const userType =
    entry.activity_type === 'MESSAGE_ADDED_BY_AGENT' ? 'agent' : 'customer';

  const text = (
    <>
      Message is added by {userType} {authorLink}
    </>
  );
  const author: User = {
    id: entry.author.id,
    name: entry.author.name ?? null,
    email: entry.author.email ?? null,
    phone_number: entry.author.phone_number ?? null,
    avatar_url: entry.author_avatar_url,
    type: userType === 'agent' ? 'member' : 'contact',
    org_id: null,
    company_id: null,
    default_outbound_number: null,
    anonymized_at: null,
    given_name: null,
    family_name: null,
    is_banned_hack: null,
    has_scim_enabled: false,
    external_id: null,
    skills: null,
  };

  const message = messages.find((message) => message.id === entry.message_id);

  return (
    <LogEntry entry={entry} text={text}>
      {message?.text ? (
        <Message
          className={styles.message}
          author={author}
          markup={message.text}
          date=""
          channel={getMessageSanitizationChannel(message)}
        />
      ) : null}
    </LogEntry>
  );
};
